export default "/images/vendor/flag-icons/flags/1x1/cn.svg?2e5f836fa0364bb906e6be3db67f596a";